import { Component, OnInit, Input } from '@angular/core';
import { LanguageService } from '../../../../Services/language.service';
import { TenantService } from '../../../../Services/tenant.service';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { LowerCasePipe } from '@angular/common';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    styleUrls: ['./languages.component.css'],
    imports: [MatSidenavContainer, MatSlideToggle, LowerCasePipe]
})

export class LanguagesComponent implements OnInit {
    headerText: string = "Enable Languages";
    blockUi: boolean = false;
    tenant = this.tenantService.selectedTenant;
    languages: any[];
    editingList:any;
    constructor(
        private languageService: LanguageService,
        private tenantService: TenantService) { }

    ngOnInit(): void {
        this.blockUi = true;
        this.languageService.getLanguages(this.tenant)
            .subscribe(r => {
                this.languages = r;
                this.blockUi = false;
            });
    }

    ngDoCheck() {        
    }

    updateLanguageStatus(languageId, checked) {
        this.blockUi = true;
        this.languageService.updateLanguageStatus(this.tenant, checked, languageId).subscribe(() => {
            this.blockUi = false;
        });
    }

    updateTranslateStatus(languageId, checked) {
        this.blockUi = true;
        this.languageService.updateTranslateStatus(this.tenant, checked, languageId).subscribe(() => {
            this.blockUi = false;
        });
    }
}
